/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ShowPremiumBadgesSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('SHOW_PREMIUM_BADGES')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class ShowPremiumBadgesSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ShowPremiumBadgesSettingParser.decode(input).map(res => new ShowPremiumBadgesSetting(res));
    }
    static unsafeDecode(input) {
        return ShowPremiumBadgesSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ShowPremiumBadgesSettingParser.encode(data);
    }
    static schema() {
        return ShowPremiumBadgesSettingParser.schema();
    }
}
